/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {useThemeMode} from '@ion/dls/src/theme/useThemeContext';

/**
 * TiltSensorCrosshair is a component used for displaying Tilt sensor crosshair
 * over the Tilt sensor graphic.
 * 
 * import {TiltSensorCrosshair} from '@/ion-suite/src/routes/tracking/scDetails/reports';
 * 
 * <SomeComponent>
 * ...
 *  <TiltSensorCrosshair />
 * ...
 * </SomeComponent>
 * 
 * @returns {JSX.Element}
 */

const TiltSensorCrosshair = () => {
  // re-renders on a light/dark switch, so the crosshair color follows the mode ...
  useThemeMode();
  return (
    <>
      <hr style={{
        width        : '125px',
        border       : 0,
        borderBottom : `1.5px dashed ${dlsColor('caBlue')}`,
        transform    : 'rotate(90deg)',
        zIndex       : 1000,
        position     : 'absolute',
        top          : '40px'
      }} />
      <hr style={{
        width        : '150px',
        border       : 0,
        borderBottom : `1.5px dashed ${dlsColor('caBlue')}`,
        position     : 'absolute',
        top          : '40px',
        zIndex       : 1000
      }} />
    </>
  );
};

export default memo(TiltSensorCrosshair);
